import React, { useState } from "react";
import { FieldError } from "../FieldError";
import {
  Control,
  Controller,
  Path,
  UnPackAsyncDefaultValues,
} from "react-hook-form";
import { DatePickerInput } from "./DatePickerInput";

type Props<T> = {
  name: Path<UnPackAsyncDefaultValues<T>>;
  className?: string;
  startDate?: Date;
  selectedDate?: Date;
  control: Control<T>;
  error?: string;
  placeholder?: string;
  value?: Date | string;
};

export const DateField = <T,>(props: Props<T>) => {
  const [,] = useState(new Date());

  return (
    <div>
      <Controller
        control={props.control}
        name={props.name}
        render={({ field: { onChange, onBlur, value } }) => {
          const inputValue = value as Date;
          //if(typeof inputValue === 'string') {
          //  inputValue = new Date(value as Date)
          //}
          return (
            <DatePickerInput
              placeholder={props.placeholder}
              onChange={onChange}
              onBlur={onBlur}
              selected={inputValue}
              error={!!props.error}
            />
          );
        }}
      />

      {props.error && <FieldError>{props.error}</FieldError>}
    </div>
  );
};
